import { Paragraph } from "shared/components";

import styles from "./Item.module.scss";

export const Item = ({ items }) => {
  return (
    <div className={styles.items}>
      {items.map((item) => (
        <div className={styles.item} key={item.id}>
          <Paragraph color="blue" uppercase className={styles.date}>
            {item.dateTo}
          </Paragraph>
          <Paragraph color="grey" appearance="bold" className={styles.price}>
            {item.price}
          </Paragraph>
          <Paragraph color="dark" className={styles.additional}>
            {item.additionalPriceNotes}
          </Paragraph>
        </div>
      ))}
    </div>
  );
};
